import { Container, Text } from 'pixi.js';
import { linear } from '../util';

class ScoreText extends Container {
  public targetScore: number;
  public baseScore: number;
  public currentScore: number;
  public dt: number;
  public targetDT: number;
  public textFields: Text;

  constructor() {
    super();

    this.targetScore = 0;
    this.baseScore = 0;
    this.currentScore = 0;
    this.dt = 0;
    this.targetDT = 30;

    this.textFields = new Text('0', {
      fontSize: 30,
      fontWeight: '700',
      fontFamily: 'ff-providence-sans-web-pro, sans-serif',
      fontStyle: 'normal',
      letterSpacing: -2,
      fill: '#4a282f',
      stroke: '#ffffff',
      strokeThickness: 4,
    });
    this.addChild(this.textFields);
  }

  public setTargetScore(score: number): void {
    if (this.targetScore !== score) {
      this.baseScore = this.currentScore;
      this.targetScore = score;
      this.dt = 0;
    }
  }

  public update(elapsed: number): void {
    this.dt += elapsed;
    if (this.dt >= this.targetDT) {
      this.dt = this.targetDT;
    }

    this.currentScore = this.baseScore + (this.targetScore - this.baseScore) * linear(this.dt / this.targetDT);
    this.textFields.text = Math.round(this.currentScore).toString();
  }
}

export default ScoreText;
